import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBpOB_TTjcFz98hPv_6HesdjTHbvOJ3Xe8',
  authDomain: 'hanaharmoney-c35b3.firebaseapp.com',
  projectId: 'hanaharmoney-c35b3',
  storageBucket: 'hanaharmoney-c35b3.firebasestorage.app',
  messagingSenderId: '915268016076',
  appId: '1:915268016076:web:e6f7be515dca80330c6f69',
  measurementId: 'G-8GFYLL6Y9V',
};

export const firebaseApp = initializeApp(firebaseConfig);
